import { useMutation, useQuery } from '@tanstack/react-query';
import { privyService } from '../services/privy.service';

/**
 * Mutation to start Privy registration
 */
export const usePrivyRegistration = () => {
  return useMutation({
    mutationFn: () => privyService.startRegistration(),
  });
};

/**
 * Query to poll Privy registration status
 */
export const usePrivyStatus = (enabled: boolean = false) => {
  return useQuery({
    queryKey: ['privy', 'status'],
    queryFn: () => privyService.checkStatus(),
    enabled,
    refetchInterval: 5000, // Poll every 5 seconds
    staleTime: 0,
  });
};

/**
 * Mutation to resend registration (soft-reject retry)
 */
export const usePrivyResend = () => {
  return useMutation({
    mutationFn: () => privyService.resend(),
  });
};

/**
 * Mutation to restart registration with a new reference_number (OTP limit hit)
 */
export const usePrivyRestart = () => {
  return useMutation({
    mutationFn: () => privyService.restart(),
  });
};
